const animationNodeTypes = new Set([
  'playAnimation',
  'characterMoveTo',
  'stopAnimation',
  'stopAllAnimationsOfObject',
  'stopAllAnimations',
  'stopPlayback',
]);

const audioNodeTypes = new Set([
  'playAudio',
  'stopAudio',
  'stopPlayback',
]);

const videoNodeTypes = new Set([
  'playVideo',
  'stopVideo',
  'stopPlayback',
]);

const audioPlayerNodeTypes = new Set([
  'playerLoadTrack',
  'playerPlay',
  'playerPause',
  'playerResume',
  'playerStop',
  'playerSeek',
  'playerSetVolume',
  'playerShow',
  'playerHide',
  'playerToggleVisibility',
  'onPlayerPlay',
  'onPlayerPlayAndAudioActive',
  'onPlayerTrackFinished',
  'onPlayerTrackFinishedAndAudioActive',
  'onPlayerPaused',
  'onPlayerPausedAndAudioActive',
  'onPlayerOpened',
  'onPlayerClosed',
  'getPlayerIsPlaying',
  'getPlayerCurrentTime',
  'getPlayerDuration',
  'getPlayerProgress',
  'getPlayerVolume',
]);

const trayChoiceNodeTypes = new Set(['traySpawnChoice']);

export function nodeTypeRequiresAnimation(nodeType: string): boolean {
  return animationNodeTypes.has(nodeType);
}

export function nodeTypeRequiresAudio(nodeType: string): boolean {
  return audioNodeTypes.has(nodeType);
}

export function nodeTypeRequiresVideo(nodeType: string): boolean {
  return videoNodeTypes.has(nodeType);
}

export function nodeTypeRequiresAudioPlayer(nodeType: string): boolean {
  return audioPlayerNodeTypes.has(nodeType);
}

export function nodeTypeRequiresTrayChoice(nodeType: string): boolean {
  return trayChoiceNodeTypes.has(nodeType);
}
